import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface RedirectUrl {
  redirectUrl: string;
}

export type GetFullUrlCall = (token: string) => Promise<{ data: RedirectUrl }>;

export default (makeCall: MakeCall) => (token: string) =>
  makeCall<RedirectUrl>('GET', `/api/v2/shortlink/${token}`);
